import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import ShoppingCartButton from './ShoppingCartButton'
import InsuredVehiclesButton from './InsuredVehiclesButton'
import InsuredVehicleItem from './InsuredVehicleItem'
import PopupView from './forms/PopupView'
import Button from './Button';
import Overlay from './Overlay';
import { FaBars } from '@react-icons/all-files/fa/FaBars';
import { Dropdown, Space } from 'antd'
import { Helpers } from '../utilities/helpers'
import { cdnDomain } from '../utilities/config';
import TextInput from './forms/TextInput';
import Validators from '../utilities/validators';
import { MotorService } from '../services/motorService';
import Alert from './forms/Alert';
import ButtonSpinner from './forms/ButtonSpinner';
import ColorThemeButton from './ColorThemeButton'
const PineappleLogo = `${cdnDomain}/static/images/Pineapple_icon.png`
const AgentIcon = `${cdnDomain}/static/images/agent-icon.png`
import outlineLogo from '../../assets/images/Pineapple_outline_icon.png' //Outline logo for dark mode
// *** NB: Abstract the outlineLogo to AWS so that we can also access it via the CDN ***
import NavHeadingUnderline from '../../assets/images/icons/navigation-heading-underline'
import PropTypes from 'prop-types';
import { productTypes } from '../utilities/enums';

const Navigation = (props) => {
  const {
    onLogoutClick,
    showMotorShoppingCartButton,
    onShoppingCartButtonPress,
    showSideMenu,
    onSideMenuClose,
    isShoppingCartLoading,
    basketCount,
    basketItems,
    updateBasketCount,
    onAddVehicleButtonPress,
    isWhiteBackground,
    isLinkable,
    callToActionButtonText,
    leftSideLinks,
    onClickCallToAction,
    rightActionButtons,
    hideBrandNames = false,
    onSuccessPage = false,
    insuredVehicleCount,
    showInsuredVehiclesButton,
    onInsuredVehiclesButtonPress,
    onCloseInsuredVehicles,
    showInsuredVehicles,
    insuredVehicles,
    onVehicleUpdate,
    product, //Active tab indicator //see PropTypes for valid inputs.
    isDarkMode = false,
  } = props

  const [agent, setAgent] = useState(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const [isEditingInsuredVehicle, setIsEditingInsuredVehicle] = useState(false)
  const [registration, setRegistration] = useState('')
  const [vinNo, setVinNo] = useState('')
  const [engineNo, setEngineNo] = useState('')
  const [vehicle, setVehicle] = useState('')
  const [isUpdatingVehicle, setIsUpdatingVehicle] = useState(false)
  const [motorFlowTabLink, setMotorFlowTabLink] = useState('/car-insurance/get-started')
  const [homeContentsFlowTabLink, setHomeContentsFlowTabLink] = useState('/home-contents-insurance/get-started')

  const PineappleLogo = isDarkMode ? outlineLogo : `${cdnDomain}/static/images/Pineapple_icon.png`
  const AgentIcon = `${cdnDomain}/static/images/agent-icon.png`
  const buildingAndContentsSubTitle = 'Home Contents Insurance'

  //Get uuid and append to links
  useEffect(() => {
    async function getUserId() {
      const userId = await Helpers.getAuthUserId()

      if (userId) {
        setMotorFlowTabLink(`/car-insurance/get-started?uuid=${userId}`)
        setHomeContentsFlowTabLink(`/home-contents-insurance/get-started?uuid=${userId}`)
      }
    }

    getUserId()
  }, []);

  useEffect(() => {
    // check if there is an agent signed in
    // Retrieve agent data from storage and parse it as JSON
    const fetchAgentFromStorage = async () => {
      try {
        const agentData = await Helpers.getInStorage('sales_agent', true)
        if (agentData) {
          const agent = JSON.parse(agentData)
          setAgent(agent)
        }
      } catch (error) {
        console.error('Error retrieving agent data:', error)
      }
    }

    fetchAgentFromStorage()
  }, [])

  const onCloseInsuredVehiclesModal = () => {
    onCloseInsuredVehicles()
    setRegistration('')
    setVinNo('')
    setEngineNo('')
    setIsEditingInsuredVehicle(false)
  }

  const renderInsuredVehiclesContent = () => {
    return (
      <div>
        <div className='insured-vehicles-text-container' >
          <p style={{ fontWeight: 'bold' }}>
            These are all the vehicles you currently have insured on
            your policy. Ensure that you've reviewed them before
            attempting to insure any additional vehicles to your
            existing policy.
          </p>
        </div>
        <div className='insured-vehicles-actions-wrapper'>
          <div className='insured-vehicles-scroll-wrapper'>
            {(insuredVehicles || []).map((vehicle, index) => (
              <InsuredVehicleItem
                vehicle={vehicle}
                key={vehicle.id}
                onEdit={() => {
                  setIsEditingInsuredVehicle(true)
                  setVehicle(vehicle)
                  setRegistration(vehicle.registration ? vehicle.registration.toUpperCase() : '')
                  setVinNo(vehicle.vinNo ?? '')
                  setEngineNo(vehicle.engineNo ?? '')
                }}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }

  const updateVehicle = async () => {
    const params = {
      vehicle_id: vehicle.id,
      registration: registration.toUpperCase(),
      vin_no: vinNo.toUpperCase(),
      engine_no: engineNo.toUpperCase(),
    }

    setIsUpdatingVehicle(true)
    const response = await MotorService.updateVehicleMTA(params)
    setIsUpdatingVehicle(false)

    if (!response.success) {
      return Alert.alert(
        'Error updating',
        typeof response.message === 'string'
          ? response.message
          : 'Something went wrong'
      )
    }

    const updatedInsuredVehicles = insuredVehicles.map((insuredVehicle) => {
      if (insuredVehicle.id === vehicle.id) {
        insuredVehicle ={
          ...insuredVehicle,
          registration: registration ? registration : insuredVehicle.registration,
          vinNo: vinNo ? vinNo : insuredVehicle.vinNo,
          engineNo: engineNo ? engineNo : insuredVehicle.engineNo,
        }
      }

      return insuredVehicle
    })

    onVehicleUpdate(updatedInsuredVehicles)
    onCloseInsuredVehiclesModal()
  }

  const renderEditModal = () => {
    return (
      <div style={{ minWidth: 300 }}>
        <div style={{ marginBottom: 12 }}>
          <TextInput
            label="Number Plate"
            placeholder="Number plate"
            name="numberPlate"
            onChange={event => setRegistration(event.target.value.toUpperCase())}
            isValid={Validators.isNumberPlate(registration)}
            value={registration.toUpperCase()}
            errorMessage={registration && 'Invalid Number Plate'}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
        <TextInput
          label="Vin Number"
          placeholder="Vehicle VIN"
          name="vinNo"
          onChange={e => setVinNo(e.target.value.toUpperCase())}
          isValid={Validators.isVin(vinNo) || vinNo === ''}
          value={vinNo.toUpperCase()}
          onBlur={() => vinNo && setVinNo(vinNo.toUpperCase())}
          errorMessage={vinNo && 'Invalid VIN number'}
        />
        </div>
        <div style={{ marginBottom: 12 }}>
        <TextInput
          label="Engine Number"
          placeholder="Engine number"
          name="engineNo"
          onChange={e => setEngineNo(e.target.value.toUpperCase())}
          isValid={Validators.isEngineNo(engineNo)}
          value={engineNo.toUpperCase()}
          onBlur={() => engineNo && setEngineNo(engineNo.toUpperCase())}
          errorMessage={engineNo && 'Invalid engine number'}
        />
        </div>
        <div className="content-box--is-content-centered">
          <ButtonSpinner
            title="Update"
            onClick={updateVehicle}
            isLoading={isUpdatingVehicle}
            disabled={
              (!registration && !engineNo && !vinNo)
              || (!Validators.isNumberPlate(registration) && registration)
              || (!Validators.isEngineNo(engineNo) && engineNo)
              || (!Validators.isVin(vinNo) && vinNo)
            }
            style={{ margin: 'auto' }}
          />
        </div>
      </div>
    )
  }

  const renderLeftSideDropdownItems = () => {
    const links = [
      ...(leftSideLinks.map((item, index) => {
        return {
          key: `${index + 1}`,
          label: (
            <a target="_blank" rel="noopener noreferrer" href={item.href}>
              {item.label}
            </a>
          )
        }
      }))
    ]

    callToActionButtonText && links.push({
      key: `${links.length + 1}`,
      label: (
        <Button title={callToActionButtonText} onClick={() => onClickCallToAction()} style={{ margin: 0 }} />
      )
    })

    return links
  }

  const renderRightActionButtons = () => {
    return (
      rightActionButtons.map((item, index) => {
        const textOnly = index === 0
        const blackBackground = index === 2
        const style = textOnly ? { marginLeft: 10, border: 'none' } : { marginLeft: 10 }
        const color = textOnly ? 'transparent' : blackBackground ? 'black' : ''

        return (
          <Button
            key={index}
            onClick={() => item.action()}
            title={item.label}
            style={style}
            color={color}
          />
        )
      })
    )
  }

  const DropDownMenuActionButton = (item) => {
    const { textOnlyButton, reactButton } = item
    const style = textOnlyButton ? { paddingBottom: 16 } : { paddingBottom: 28 }
    const className = textOnlyButton ? 'is-text-only-button' : 'is-styled-button'

    return (
      <Space style={style} className={className}>
        {reactButton}
      </Space>
    )
  }

  const handleOpenChange = (nextOpen) => {
    setShowDropdown(nextOpen);
  }

  const productNavigationLink = () => {
    return product === productTypes.motor
      ? '/car-insurance/dashboard'
      : product === productTypes.homeContents
      ? '/home-contents-insurance/get-started'
      : 'https://www.pineapple.co.za'
  }

  const SafeLink = ({ to, children, ...props }) => {
    if (to.startsWith('http') ) {
      return (
        <a href={to} {...props}>
          {children}
        </a>
      );
    }
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    );
  };

  return (
    <div
      className={`navigation ${isWhiteBackground ? 'navigation--is-white-background' : ''
        } ${agent ? 'navigation--agent' : ''}`}
    >
      <div className="navigation__left">
      <SafeLink
          to={productNavigationLink()}
          onClick={() => Helpers.removeVehicleFromStorage(onSuccessPage)}
      >
        <div>
          <img
            src={PineappleLogo}
            className="navigation__logo navigation__logo--is-centered"
          />
        </div>
      </SafeLink>
        <p className="navigation__title-is-showable">Pineapple</p>

        {agent &&
          <div className="agent-details-wrapper">
            <img className={'agent-icon'} src={AgentIcon} alt="" />
            <p className="title title--is-agent-welcome-text">{`Welcome, ${agent.first_name} ${agent.last_name}!`}</p>
          </div>
        }

        <div
          className="navigation__brand-wrapper"
          onClick={() => Helpers.removeVehicleFromStorage(onSuccessPage)}
        >
          {!agent && !hideBrandNames &&
            <SafeLink
              className="navigation__brand-name-link"
              to={productNavigationLink()}
            >
              <h4 className="navigation__brand-name">Pineapple</h4>
            </SafeLink>
          }
          <Link
            to={motorFlowTabLink}
          >
            <p className={`navigation__brand-sub-name ${product === productTypes.motor ? 'navigation__brand-sub-name--active' : ''}`}>
              Car Insurance
              <NavHeadingUnderline />
            </p>
          </Link>
          <Link
            to={'/home-contents-insurance/get-started'}
          >
            <p className={`navigation__brand-sub-name ${product === 'home-insurance' ? 'navigation__brand-sub-name--active' : ''}`}>
              {buildingAndContentsSubTitle}
              <NavHeadingUnderline />
            </p>
          </Link>
          {showInsuredVehiclesButton && (
            <div>
              <InsuredVehiclesButton
                count={insuredVehicleCount}
                style={{ float: 'right' }}
                color={'#68C9D0'}
                disabled={false}
                loading={false}
                onClick={() => onInsuredVehiclesButtonPress()}
              />
            </div>
          )}
        </div>


        {isLinkable && (
          <div className="navigation__left--is-link-container navigation-item-is--hideable_left-buttons">
            {leftSideLinks &&
              leftSideLinks.map((linkData, index) => {
                return (
                  <a
                    key={index}
                    className="navigation-link-text"
                    href={linkData.href}
                    target="_blank"
                  >
                    {linkData.label}
                  </a>
                )
              })}
          </div>
        )}
      </div>
      <div className="navigation__right">
        {!agent && false && /* added && false to hide the buttons for initial launch. Re-add when dark theme working */
        <div className='color-theme-button-container'>
          <ColorThemeButton buttonTheme='dark' />
          <ColorThemeButton buttonTheme='light' /> 
        </div>
        }
        {onLogoutClick && (
          <p className="navigation__logout-link" onClick={onLogoutClick}>
            Logout
          </p>
        )}
        {callToActionButtonText && (
          <div className="navigation__right--is-link-container">
            <div className="navigation-item-is--hideable_left-buttons">
              <Button
                onClick={() => onClickCallToAction()}
                title={callToActionButtonText}
                style={{ margin: 0 }}
              />
            </div>
            <div className="navigation-item-is--showable navigation-item-is--showable_left-buttons">
              <Dropdown
                overlayClassName={'navigation-dropdown-menu'}
                menu={{ items: renderLeftSideDropdownItems(), selectable: true }}
                placement="topLeft"
                trigger={['click']}
              >
                <a
                  className="navigation-burger-menu"
                  onClick={(e) => e.preventDefault()}
                >
                  <FaBars />
                </a>
              </Dropdown>
            </div>
          </div>
        )}
        {rightActionButtons && (
          <div className="navigation__right--is-link-container">
            <div className="navigation-item-is--hideable_right-buttons">
              {renderRightActionButtons()}
            </div>
          </div>
        )}
        {rightActionButtons || leftSideLinks ? (
          <div className="navigation__right--is-link-container">
            <div
              className={`navigation-item-is--showable ${!rightActionButtons
                ? 'navigation-item-is--showable_left-buttons'
                : 'navigation-item-is--showable_right-buttons'
                }`}
            >
              <Dropdown
                overlayClassName={'navigation-dropdown-menu'}
                overlayStyle={!showDropdown ? { display: 'none' } : {}}
                menu={{
                  items: renderLeftSideDropdownItems(),
                  onClick: () => setShowDropdown(false),
                  selectable: true,
                }}
                dropdownRender={(menu) => (
                  <div className="navigation-dropdown-menu_action-buttons">
                    {leftSideLinks ? (
                      <div
                        className="navigation-item-is--showable navigation-item-is--showable_left-buttons"
                        style={{ display: 'none' }}
                      >
                        {menu?.props?.items.map((item, index) => {
                          const button = (
                            <Button
                              key={index}
                              onClick={() => setShowDropdown(false)}
                              title={item.label}
                              style={{ marginLeft: 10, border: 'none' }}
                              color={'transparent'}
                            />
                          );

                          return (
                            <DropDownMenuActionButton
                              key={index}
                              textOnlyButton={true}
                              reactButton={button}
                            />
                          );
                        })}
                      </div>
                    ) : null}
                    {rightActionButtons
                      ? renderRightActionButtons().map((item, index) => {
                        const textOnly = index === 0;

                        return (
                          <DropDownMenuActionButton
                            key={index}
                            textOnlyButton={textOnly}
                            reactButton={item}
                          />
                        );
                      })
                      : null}
                  </div>
                )}
                onOpenChange={handleOpenChange}
                placement="topLeft"
                open={showDropdown}
                trigger={['click']}
              >
                <a
                  className="navigation-burger-menu"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaBars />
                </a>
              </Dropdown>
            </div>
          </div>
        ) : null}
        {onSuccessPage && (
          <Link to={'/car-insurance/dashboard'}>
            <Button
              title={window.screen.width < 350 ? 'Add 🚗' : 'Add Vehicle'}
              onClick={() => Helpers.removeVehicleFromStorage(onSuccessPage)}
            />
          </Link>
        )}
        {showMotorShoppingCartButton && (
          <ShoppingCartButton
            count={basketCount}
            icon={'shopping-cart'}
            color={'#68C9D0'}
            disabled={false}
            loading={isShoppingCartLoading}
            onClick={() => onShoppingCartButtonPress()}
          />
        )}
      </div>
      <Overlay
        product={product}
        placement={'end'}
        showSideMenu={showSideMenu}
        onAddVehicleButtonPress={onAddVehicleButtonPress}
        onSideMenuClose={() => onSideMenuClose()}
        loading={isShoppingCartLoading}
        basketItems={basketItems}
        basketCount={basketCount}
        updateBasketCount={updateBasketCount}
      />
      <PopupView
        visible={showInsuredVehicles}
        title={isEditingInsuredVehicle ? `Editing ${Helpers.convertWordToTitleCase(vehicle.make)} ${Helpers.convertWordToTitleCase(vehicle.model.split(' ')[0])}` : `You have ${insuredVehicleCount} insured vehicle${
          insuredVehicleCount > 1 ? 's' : ''
        }`}
        onPressClose={onCloseInsuredVehiclesModal}
        renderContent={isEditingInsuredVehicle ? renderEditModal : renderInsuredVehiclesContent}
        backgroundColor={'white'}
        isInsuredVehicles={true}
        width={'auto'}
        hideCloseButton={false}
      />
    </div>
  )
}

Navigation.propTypes = {
  product: PropTypes.oneOf([productTypes.motor, 'home-insurance']),
}

export default Navigation